import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const FALLBACK_SETTINGS = {
  whatsapp_number: "910000000000",
  whatsapp_message:
    "Hello RIDGELINE DIGI PARTNER, I would like to know more about your website and AI automation services.",
  business_email: "",
  business_phone: "",
  business_address: "",
  business_hours: "",
};

let settingsPromise = null;

export function getSiteSettings() {
  if (!settingsPromise) {
    settingsPromise = api
      .get("/settings/public")
      .then((r) => ({ ...FALLBACK_SETTINGS, ...r.data }))
      .catch(() => FALLBACK_SETTINGS);
  }
  return settingsPromise;
}

export function refreshSiteSettings() {
  settingsPromise = null;
  return getSiteSettings();
}

export function waLink(settings, overrideMessage) {
  const num = String(settings?.whatsapp_number || FALLBACK_SETTINGS.whatsapp_number).replace(/\D/g, "");
  const msg = encodeURIComponent(
    overrideMessage || settings?.whatsapp_message || FALLBACK_SETTINGS.whatsapp_message
  );
  return `https://wa.me/${num}?text=${msg}`;
}

export function adminApi() {
  const token = localStorage.getItem("rdp_admin_token");
  return axios.create({
    baseURL: API,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
}

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return String(detail);
}
